package com.dotdrives.client

import com.dotdrives.model.Profile
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.postgrest.from

class ProfileClient(
    private val client: SupabaseClient = SupabaseProvider.client,
    private val authClient: AuthClient = AuthClient(client),
) {
    suspend fun me(): Profile? {
        val userId = authClient.requireCurrentUserId()
        return client.from("profiles")
            .select {
                filter {
                    eq("user_id", userId)
                }
            }
            .decodeSingleOrNull()
    }

    suspend fun upsert(profile: Profile) {
        val resolvedProfile = if (profile.userId.isBlank()) {
            profile.copy(userId = authClient.requireCurrentUserId())
        } else {
            profile
        }
        client.from("profiles").upsert(resolvedProfile)
    }
}
